<template>
    <div class="h-screen flex w-full items-center justify-center bg-white dark:bg-black">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <div v-if="has_error">
                <img src="@/assets/images/pages/404_2.png" alt="graphic-404" class="mx-auto mb-4 max-w-full" style="max-height: 250px;">
                <h4 class="sm:mx-0 mx-0 mb-6 text-2xl text-danger">
                    Authentication Failed
                </h4>
                <p class="text-grey mb-6">We couldn't authenticate your session for the Support App. Please try again or contact the administrator.</p>
                <vs-button color="primary" type="border" @click="goHome">Go to Dashboard</vs-button>
            </div>
            <div v-else class="flex flex-col items-center">
                <!-- Vuexy/vuesax loading spinner will show, but let's also render a clean custom placeholder -->
                <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mb-4"></div>
                <h4 class="sm:mx-0 mx-0 text-xl font-medium">
                    Redirecting to Support App...
                </h4>
                <p class="text-grey mt-2">Please wait while we establish your secure session.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const StaffRepository = RepositoryFactory.get('staff')
import { SUPPORT_APP_URL } from "@/constants/config";

export default {
    name: "SupportAppAuth",
    data() {
        return {
            has_error: false
        }
    },
    async mounted() {
        this.$vs.loading({
            type: 'sound'
        })
        try {
            // Fetch the Support App SSO Token
            const response = await StaffRepository.fetchSupportAppToken()
            const { data } = response.data
            
            if (data && data.sso_token) {
                // Parse existing query parameters from current URL robustly
                const params = new URLSearchParams()
                
                // 1. Get parameters from window.location.search
                const urlParams = new URLSearchParams(window.location.search)
                for (const [key, value] of urlParams.entries()) {
                    params.set(key, value)
                }
                
                // 2. Merge/fallback with vue-router's query params to be extra sure
                if (this.$route.query) {
                    for (const key in this.$route.query) {
                        const val = this.$route.query[key]
                        if (val !== undefined && val !== null) {
                            params.set(key, val)
                        }
                    }
                }

                params.set('code', data.sso_token)
                params.set('type', 'Nimble')
                
                // Redirect in the same tab
                const targetUrl = `${SUPPORT_APP_URL}/auth?${params.toString()}`
                window.location.href = targetUrl
            } else {
                throw new Error("Invalid SSO token response")
            }
        } catch (error) {
            console.error("Support App Auth Redirection Error:", error)
            this.has_error = true
        } finally {
            this.$vs.loading.close()
        }
    },
    methods: {
        goHome() {
            this.$router.push('/')
        }
    }
}
</script>

<style scoped>
.animate-spin {
    animation: spin 1s linear infinite;
}
@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
